import PropTypes from "prop-types";
import { Content } from "@circle-react/components/Spaces/CourseSpace/Summary/Content";

export const LessonsBlock = ({ isEnrolled = false, sections = [] }) => (
  <div className="bg-primary flex w-full flex-col items-center py-10">
    <div className="w-full max-w-[960px] px-6">
      <Content isEnrolled={isEnrolled} sections={sections} />
    </div>
  </div>
);

LessonsBlock.propTypes = {
  isEnrolled: PropTypes.bool,
  sections: PropTypes.array,
};
